import React, { useCallback, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import { actions as coreActions, selectors as coreSelectors, hooks as coreHooks } from 'mage-core';
import { translator } from 'mage-i18n';
import { SpacerVertical, BorderlessDropdown } from '@klarna/bubble-ui';
import { analytics, HorizontalWrapper } from 'moet-core';

import { CallToActionButton, ContainerTemplate } from '@/components';
import { selectMid } from '@/actions/midSelector';
import { getSelectableMerchants } from '@/selectors/merchant';
import { isFetchingMerchant, isFetchingProducts } from '@/selectors/loadingStates';

const tPrefix = 'products-fe.containers.mid-selector';

const MidSelectorPage = ({ isLoading, selectableMerchants, dispatchSelectMid, setMid, t }) => {
  const [selectedMid, setSelectedMid] = useState();
  const tokenHelper = coreHooks.useTokenHelper();
  const tokenMids = tokenHelper.getMidsForClient('products-fe');

  const options = [
    { label: '', key: '' },
    ...tokenMids.map(mid => {
      const m = selectableMerchants?.find(m => mid === m.id);
      return {
        key: mid,
        label: `${mid}${
          m?.businessDetails?.storeName ? ` (${m?.businessDetails?.storeName})` : ''
        }`,
      };
    }),
  ];

  const selectMerchant = useCallback(() => {
    if (selectedMid) {
      setMid(selectedMid);
      analytics.login({ customerid: selectedMid });
      setTimeout(() => {
        dispatchSelectMid(selectedMid);
      }, 1);
    }
  }, [selectedMid, setMid, dispatchSelectMid]);

  return (
    <ContainerTemplate title={t(`${tPrefix}.title`)} subtitle={t(`${tPrefix}.subtitle`)}>
      <SpacerVertical spaceToken="space/150" />
      <BorderlessDropdown
        tabIndex={0}
        label={t(`${tPrefix}.mid-selector`)}
        options={options}
        disabled={isLoading}
        onChange={setSelectedMid}
      />
      <SpacerVertical spaceToken="space/600" />
      <HorizontalWrapper display="inline-flex" alignItems="center" justifyContent="flex-end">
        <CallToActionButton
          tabIndex={1}
          onClick={selectMerchant}
          loading={isLoading}
          disabled={!selectedMid || isLoading}
        >
          {t(`${tPrefix}.buttons.next`)}
        </CallToActionButton>
      </HorizontalWrapper>
    </ContainerTemplate>
  );
};

MidSelectorPage.propTypes = {
  dispatchSelectMid: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  selectableMerchants: PropTypes.array.isRequired,
  setMid: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default compose(
  connect(
    state => ({
      basePath: `/${coreSelectors.slug(state)}`,
      mids: coreSelectors.getMerchantIds(state),
      selectableMerchants: getSelectableMerchants(state),
      isLoading: isFetchingMerchant(state) || isFetchingProducts(state),
      t: translator(state),
    }),
    dispatch => ({
      dispatchSelectMid: mid => dispatch(selectMid(mid)),
      setMid: mid => dispatch(coreActions.mid.set(mid)),
    }),
  ),
)(MidSelectorPage);
